import React from 'react';
import { connect } from 'react-redux';
import PromoCodeModal from '../payments/modals/PromoCodeModal';
import AddBankAccountModal from '../bankAccounts/modals/AddBankAccountModal';
import UpdateBankAccountModal from '../bankAccounts/modals/UpdateBankAccountModal';
import OTPModal from '../OTP/modal/OTPModal';
import KYCModal from '../KYC/KYCModal';
import TwoFAModal from '../twoFA/TwoFAModal';

const modalLookup = {
  PromoCodeModal,
  AddBankAccountModal,
  UpdateBankAccountModal,
  OTPModal,
  KYCModal,
  TwoFAModal,
};

const mapState = (state) => ({
  currentModal: state.modals,
})

const ModalManagerContainer = ({currentModal}) => {
  let renderedModal;

  if(currentModal) {
    const {modalType, modalProps} = currentModal;
    const ModalComponent = modalLookup[modalType];

    renderedModal = <ModalComponent {...modalProps} />
  }
  return <span>{renderedModal}</span>
}

export default connect(mapState)(ModalManagerContainer);
